export default "/_next/static/images/33842c5bd7e98d97d57ecd9d13341775.jpg";